import { Language } from '@wix/thunderbolt-becky-types';
import { WTwitterLanguage } from './types';

export const getLanguage = (
  dataLang: WTwitterLanguage,
  userLang: Language,
): string => {
  return dataLang === 'userLang' ? userLang : dataLang;
};
